import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities';

class BrokerAccountRepository {
  get basePath() {
    return store.state.backend;
  }

  get tokenFromQuery() {
    if (typeof window === 'undefined') return null;
    return new URLSearchParams(window.location.search).get('token');
  }

  createBrokerAccount(brokerAccount) {
    const headers = { Authorization: store.state.token };
    let response = axios.post(`${this.basePath}/broker-accounts`, brokerAccount, { headers });
    return verifyAuth(response);
  }

  updateBrokerAccount(brokerAccount) {
    const headers = { Authorization: store.state.token };
    let response = axios.put(`${this.basePath}/broker-accounts`, brokerAccount, { headers });
    return verifyAuth(response);
  }

  deleteBrokerAccount(brokerAccountId) {
    const headers = { Authorization: store.state.token };
    let response = axios.delete(`${this.basePath}/broker-accounts/${brokerAccountId}`, { headers });
    return verifyAuth(response);
  }

  allBrokerAccountsOfUser() {
    const headers = { Authorization: store.state.token };
    const url = (store.state.whitelabel !== null && store.state.whitelabel.partner !== null)
      ? `${this.basePath}/ext/broker-accounts/user/by-partner?partnerId=${store.state.whitelabel.partner.id}`
      : `${this.basePath}/ext/broker-accounts/user`;
    let response = axios.get(url, { headers });
    return verifyAuth(response);
  }

  addGtcBrokerAccount(brokerAccount) {
    const headers = { Authorization: store.state.token };
    let response = axios.post(`${this.basePath}/ext/broker-accounts/add-gtc-account`, brokerAccount, { headers });
    return verifyAuth(response);
  }

  allBrokerAccountsOfExternalUser(userId) {
    const headers = { Authorization: store.state.token };
    let response = axios.get(`${this.basePath}/ext/broker-accounts/user/external?userId=${userId}`, { headers });
    return verifyAuth(response);
  }

  verifyBrokerAccount(accountId) {
    const headers = { Authorization: store.state.token };
    let response = axios.get(`${this.basePath}/ext/broker-accounts/verify?accountId=${accountId}`, { headers });
    return verifyAuth(response);
  }

  serverDetailsByBroker(brokerId) {
    const headers = { Authorization: store.state.token };
    let response = axios.get(`${this.basePath}/meta-trader-server-details/by-broker/${brokerId}`, { headers });
    return verifyAuth(response);
  }

  //Antes tomaba token desde router.currentRoute → romper ciclo
  serverDetailsByVersion(version) {
    const fallback = this.tokenFromQuery ? `Bearer ${this.tokenFromQuery}` : null;
    const headers = { Authorization: store.state.token || fallback };
    let response = axios.get(`${this.basePath}/meta-trader-server-details/by-version/${version}`, { headers });
    return verifyAuth(response);
  }

  serverGroupByMTServerDetails(mtServerDetailsId) {
    const headers = { Authorization: store.state.token };
    let response = axios.get(`${this.basePath}/meta-trader-server-group/by-metatrader-server-group/${mtServerDetailsId}`, { headers });
    return verifyAuth(response);
  }

  getAllBrokers() {
    return axios.get(`${this.basePath}/brokers`);
  }
}

export default new BrokerAccountRepository();
